import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import {imageClick} from 'lib';
/**
 * Simple
 */
const Simple = ({ boxStyle, item, viewType, simpleKey, name }) => {
  /*    const dispatch = useDispatch();
   dispatch(TTSList(item.text)); */
  /* console.log(item); */
  const speechSet = text => {
    imageClick(text);
  };

  return (
    <>
      {simpleKey === 0 ? (
        <div className="_text_div_init">
          <div className="_message_init">{ReactHtmlParser(item.text || '')}</div>
        </div>
      ) : (
        <div className="_text_div">
          {/*           <div className="_message" id={`_message_${item.text}`} style={boxStyle}> */}
          <div className="_message" style={boxStyle} onClick={()=>speechSet(item.text)}>
            {/*   {ReactHtmlParser(speechSet(item))} */}
            {ReactHtmlParser(item.text || '')}
          </div>
        </div>
      )}
    </>
  );
};
Simple.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  name: PropTypes.string,
  simpleKey: PropTypes.number,
};
Simple.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  simpleKey: 0, // advise, simulator, knowledge
  name: '', // advise, simulator, knowledge
};

export default Simple;
